import { RemoveLinkedAccountData, RemoveLinkedAccountVars } from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../gql';
import { useMutation } from '@apollo/client';

/**
 * @param parentkey Optional identifier of parent account whose data to re-fetch.
 */
export function useUnlink(parentkey?: number) {
  async function removeLinkedAccount(userkey: number) {
    await _removeLinkedAccount({
      variables: {
        userkey
      }
    });
  }

  const [
    _removeLinkedAccount,
    {
      loading: removeLoading,
      error: removeLinkedAccountError,
      data: removeLinkedAccountData
    }
  ] = useMutation<RemoveLinkedAccountData, RemoveLinkedAccountVars>(
    GraphQL.Mutation.REMOVE_LINKED_ACCOUNT,
    {
      client: ApolloClientService.create(Config.USER_GQL),
      refetchQueries: parentkey
        ? [
            {
              query: GraphQL.Query.LINKED_ACCOUNTS,
              variables: {
                parentkey
              }
            }
          ]
        : [],
      awaitRefetchQueries: true
    }
  );

  return {
    removeLoading,
    removeLinkedAccount,
    removeLinkedAccountData,
    removeLinkedAccountError
  };
}
